module.exports = __webpack_public_path__ + "static/media/Propos.aee2d331.pdf";